import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'gatsby';
import CartCheckout from './CartCheckout';
import shoppingBag from '../../images/shopping-bag.png';
import { CartContext } from '../Context/CartContext';
import CartItem from './CartItem';
import CartHandler from '../Services/CartService';
import { useGlobalDispatch } from '../Context/globalContext';
import Loader from "react-loader-spinner";
import { setTokenExpireTimeToZero, licenseUser } from '../Services/auth';

const CartData = () => {

  const context = useContext(CartContext);
  const {cartData, orderItem, message, loaded, itemCount} = context.state;
  const [storeLocation, setStoreLocation] = useState('');

  const globalDispatch = useGlobalDispatch();

  useEffect(() => {
    globalDispatch({type: 'meta', payload: {pageTitle: 'Cart'}});
    getData()
  }, []);

  useEffect(() => {
    setDataForAttributes();
  }, [cartData]);

  const getData = async () => {
    let res = await CartHandler.getCartItem();
    let member = await licenseUser();
    const currentDate = new Date();
    
    // If the active license has date less than current date it means 
    // subscription is unlimited.
    if(member?.expires && new Date(member.expires) < currentDate) {
      globalDispatch({type: 'member', payload: {member: 'unlimited'}});
    } else {
      globalDispatch({type: 'member', payload: {member: member}});
    }
   
    if(res?.message === "Access token has been revoked") {
      setTokenExpireTimeToZero();
      res = await CartHandler.getCartItem();
      member = await licenseUser();
      const currentDate = new Date();

      // If the active license has date less than current date it means 
      // subscription is unlimited.
      if(member?.expires && new Date(member.expires) < currentDate) {
        globalDispatch({type: 'member', payload: {member: 'unlimited'}});
      } else {
        globalDispatch({type: 'member', payload: {member: member}});
      }
    }
    context.dispatch({ type: 'cartData', data: res});
  };

  // Set Attribute values
  const setDataForAttributes = async () => {
    if (cartData.length > 0) {
      // Only update initially
      !orderItem.length && context.dispatch({ type: 'orderItem', data: cartData[0].order_items });
      context.dispatch({ type: 'totalPrice', data: cartData[0].total_price.number });
    }
  };

  const setStoreLocationCallback = (callBackData) => {
    setStoreLocation(callBackData);
  };


  const displayCartItem = () => {
    const item = orderItem.map((cartItem, i) => {
      cartItem['index'] = i;
      return (
        <CartItem key={i} {...cartItem} getStoreLocationCallback={setStoreLocationCallback} />
      )
    });
    return item;
  };

  const displayEmptyCartItem = () => (
    <div className="sta-page-wrapper">
      <div className="empty-message empty-cart">
        <img src={shoppingBag} alt="your cart is empty" />
        <h3>{message}</h3>
        <p>Before proceeding to checkout, you must add some products to your cart.</p>
        <Link className="button-black" to="/products">Start Shopping!</Link>
      </div>
    </div>
  );
  return (
    <>
      {loaded ?
        
      cartData.length > 0 && cartData[0].order_items.length > 0
        ? (
          <div>
            <div className="page-header">
              <h3 className="page-header-title">SHOPPING BAG</h3>
              <span className="page-header-count">
                {itemCount}
                {itemCount > 1
                  ? <span> items</span>
                  : <span> item </span>}
              </span>
            </div>
            <div className="sta-page-wrapper">
              <div className="cart-page-container">
                <div className="cart-products">
                  {displayCartItem()}
                </div>
                <CartCheckout {...storeLocation} />
              </div>
            </div>
          </div>
        )
        : <div>{ displayEmptyCartItem() }</div>
      :
      <Loader
        type="Circles"
        color="#00BFFF"
        height={100}
        width={100}
        className="loader"
      />
      }
    </>
  );
};

export default CartData;
